import {
    FETCH_HEATMAP_OUTLIERS_DATA_START,
    FETCH_HEATMAP_OUTLIERS_DATA_SUCCESS,
    FETCH_HEATMAP_OUTLIERS_DATA_FAILED
} from '../../../constants';
import { FETCH_HEATMAP_OUTLIERS_URL } from '../../../../../config/constants';
import { ApiBase } from '../../../../utils/apiBase';
import { withType } from '../../../../utils/actionOperations';
import { getDataFromUrlToken } from '../../../../utils/urlDataStore';
import { URL_DATA } from '../../../../../config/urlDataConstants';
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { getURLFilterAndByScore } from '../../../../utils/byScoreFilterUtils';
import { getSelectedUserData } from '../../../../Routes/NewDashboard/subroutes/Explore/helper';

export const fetchHeatmapOutlierBasedOnColomn = (payload) => {
    let filters = getDataFromUrlToken(URL_DATA.DASHBOARD_FILTER);
    let filterData = getURLFilterAndByScore(filters)
    let selectedUserData = getSelectedUserData();
    const apiBaseInstance = new ApiBase();

    return dispatch => {
        dispatch(withType(FETCH_HEATMAP_OUTLIERS_DATA_START, {

        }));
        apiBaseInstance.instance
            .post(FETCH_HEATMAP_OUTLIERS_URL,
                {
                    ...payload, ...getProjectIdAndOrgId(payload), ...filterData,
                    ...selectedUserData,
                })
            .then(response => {
                dispatch(withType(FETCH_HEATMAP_OUTLIERS_DATA_SUCCESS, {
                    data: response.data,
                    request: payload
                }));
            })
            .catch(err => {
                dispatch(withType(FETCH_HEATMAP_OUTLIERS_DATA_FAILED, {
                    error: err
                }));
            });
    };
};

